var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:[
    _vm.containerClassName,
    {
      'slds-input-has-icon':
        _vm.variant !== 'counter' && (_vm.$slots.iconLeft || _vm.$slots.iconRight),
      'slds-input-has-icon_left': _vm.$slots.iconLeft && !_vm.$slots.iconRight,
      'slds-input-has-icon_right': !_vm.$slots.iconLeft && _vm.$slots.iconRight,
      'slds-input-has-icon_left-right':
        _vm.variant !== 'counter' && _vm.$slots.iconLeft && _vm.$slots.iconRight,
      'slds-input-has-fixed-addon':
        _vm.$slots.fixedTextLeft || _vm.$slots.fixedTextRight,
    } ]},'div',_vm.containerAttrs,false),[_vm._t("iconLeft"),(_vm.$slots.fixedTextLeft)?_c('span',{staticClass:"slds-form-element__addon"},[_vm._t("fixedTextLeft")],2):_vm._e(),(!_vm.isStatic)?[_c('input',_vm._g(_vm._b({ref:"input"},'input',Object.assign({}, _vm.$attrs,
        {class: [
          'slds-input',
          { 'slds-text-align_left': _vm.variant === 'counter' && _vm.readonly },
          _vm.className ],
        id: _vm.id,
        readonly: _vm.readonly,
        style: _vm.inputStyle,
        value: _vm.value}),false),Object.assign({}, _vm.$listeners,
        {input: function ($event) { return _vm.$emit('input', $event.target.value); }}))),(_vm.hasSpinner)?[_c('div',{staticClass:"slds-input__icon-group slds-input__icon-group_right"},[_c('slds-spinner',_vm._b({},'slds-spinner',{
            id: (_vm.id + "-loading"),
            assistiveText: { label: _vm.assistiveText.spinner },
            isInput: true,
            size: 'x-small',
            variant: 'brand',
          },false)),_vm._t("iconRight")],2)]:[_vm._t("iconRight")]]:[_c('div',_vm._g({class:[
        'slds-form-element__static',
        'slds-grid',
        { 'slds-grid_align-spread': _vm.variant !== 'counter' } ]},Object.assign({}, _vm.$listeners)),[_vm._v(" "+_vm._s(_vm.value)+" "),_vm._t("inlineEditTrigger")],2)],(_vm.$slots.fixedTextRight)?_c('span',{staticClass:"slds-form-element__addon"},[_vm._t("fixedTextRight")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }